import { render, staticRenderFns } from "./classType.vue?vue&type=template&id=5c92dafb&scoped=true&"
import script from "./classType.vue?vue&type=script&lang=js&"
export * from "./classType.vue?vue&type=script&lang=js&"
import style0 from "./classType.vue?vue&type=style&index=0&id=5c92dafb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c92dafb",
  null
  
)

export default component.exports